import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const CpcTable = ({ cpc, onRemove, onUpdate }) => {
    const rows = cpc.map(({ country, cpc }, index) => <Row key={index} country={country} cpc={cpc} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th>Country</th>
                    <th>Cpc</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default CpcTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffersCpc/components/Table/index.js